<template>
  <div class="regist-page">
    <div class="form">
      <div class="title-img"><img src="@/assets/tobesupplier.png" width="420" alt=""></div>
      <el-form
        :rules="companyRules"
        ref="form"
        label-position="right"
        label-width="30%"
        :model="form"
      >
        <el-form-item label="公司名称" prop="company">
          <el-input v-model="form.company" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="主营产品" prop="mainProduct">
          <el-input v-model="form.mainProduct" placeholder="请输入主营产品"></el-input>
        </el-form-item>
        <el-form-item label="年销售额(万)" prop="salesVolume">
          <el-input v-model="form.salesVolume" placeholder="请输入年销售额"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="linkman">
          <el-input v-model="form.linkman" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="telphone">
          <el-input :maxlength="11" v-model="form.telphone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="邮箱地址" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱地址"></el-input>
        </el-form-item>
        <el-form-item label="网址">
          <el-input v-model="form.website" placeholder="请输入网址"></el-input>
        </el-form-item>
        <el-form-item label="其他说明">
          <el-input type="textarea" v-model="form.remarks" placeholder="请输入其他说明"></el-input>
        </el-form-item>

        <!-- <el-form-item label style="height: 20px;">
          <div style="line-height: 1">
            <el-checkbox style="margin-right: 4px" v-model="isRead" />我已阅读并接受
            <button type="button" class="common-btn-text">《库蜂网用户协议》</button>
          </div>
        </el-form-item> -->
            <!-- :disabled="!isRead" -->
        <el-form-item>
          <button
            type="button"
            style="width: 420px;height: 39px;font-size:18px;"
            class="common-btn-primary"
            @click="submitForm('form')"
          >提交</button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  getCheckCode,
  register,
  upload,
  fileUrl,
  checkUsername,
  checkTelphone
} from "@/js/api";
import { validateEmail, isInteger } from "@/utils/util";

export default {
  name: "UserHome",
  data() {
    var checkTel = (rule, value, callback) => {
      if(value){
        const reg =/^[1][3-9][0-9]{9}$/;
        if ((!reg.test(value)) && value != '') {
          callback(new Error('请输入正确的电话号码'));
        }else {
          callback();
        }
      }
      checkTelphone({
        telphone: value
      }).then(res => {
        if (res.code == 0) {
          callback();
        } else {
          callback(new Error("手机号已注册"));
        }
      });
    };
    var checkName = (rule, value, callback) => {
      checkUsername({
        username: value
      }).then(res => {
        if (res.code == 0) {
          callback();
        } else {
          callback(new Error("已注册"));
        }
      });
    };
    return {
      fileUrl,
      isRead: false,
      form: {
        userType: 2,
        username: "",
        password: "",
        repwd: "",
        idType: 1
      },
      companyRules: {
        company: [
          { required: true, message: "请输入公司名", trigger: "blur" }
          //   { validator: checkName, trigger: "blur" }
        ],
        mainProduct: [
          { required: true, message: "请输入主营产品", trigger: "blur" }
        ],
        salesVolume: [
          { required: true, message: "请输入年销售额", trigger: "change" },
          { validator: isInteger, trigger: "blur" }
        ],
        telphone: [
          { required: true, message: "请输入11位手机号", trigger: "change" },
          { min: 11, max: 11, message: "请输入11位手机号", trigger: "blur" },
          { validator: checkTel, trigger: "blur" }
        ],
        linkman: [
          { required: true, message: "请输入联系人", trigger: "change" }
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "change" },
          { validator: validateEmail, trigger: "blur" }
        ]
      },
      telFlag: true
    };
  },
  methods: {
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.form.idPath = IP + "/kufeng-admin/" + res.result;
        this.$forceUpdate();
      }
      // this.form.idPath = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    getCheckCode() {
      if (this.form.telphone) {
        getCheckCode({
          telphone: this.form.telphone
        }).then(res => {
          if (res.code == 0) {
            // this.$message.success("验证码：" + res.result);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          register(this.form).then(res => {
            if (res.code == 0) {
              this.$message.success(res.message);
              this.$router.push("/");
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goOrder() {
      this.$router.push("/user/order");
    }
  },
  mounted() {}
};
</script>

<style>

</style>
